var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeedback = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 20,
  viewBox: "0 0 24 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2045 10H4.323V11.4704H10.2045V10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4982 6.69165H4.41113V8.16202H12.4982V6.69165Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1452 19.1901V15.5142H9.46924L13.1452 19.1901Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2334 11.3234L16.3116 10.4412L24.0001 3.01586L21.8014 0.810303L14.1129 8.16215L13.2334 11.3234Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.47037 4.48624V14.0436H18.3796V10.3677L19.85 8.89735V15.514H0V3.01587H16.9092L15.4389 4.48624H1.47037Z"
})));
export default SvgFeedback;